import { UserType } from '../../entities';
import { AppSecurityModule, AssetSecurityModule, ClaimSecurityModule, ConfigurationSecurityModule, CrmSecurityModule, DefectSecurityModule, FinanceSecurityModule, IndividualComplianceSecurityModule, JobSecurityModule, JobTemplatesSecurityModule, KnowledgeBaseSecurityModule, MobileTechniciansSecurityModule, SalesSecurityModule, QuoteSecurityModule, RecurringJobSecurityModule, ReportSecurityModule, SchedulerSecurityModule, TaskSecurityModule, TimesheetSecurityModule, VariationSecurityModule, WorkComplianceSecurityModule, DashboardSecurityModule, QuoteTemplatesSecurityModule, FormSecurityModule, EquipmentSecurityModule } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeAdministrator implements SecurityRole {

    _id = '886da031-c239-4cfe-9b69-4067355a43b5';
    system = true;
    hidden = false;
    type = UserType.Employee;
    name = SecurityRoleType.EmployeeAdministrator;
    description = 'Full access to everything in the system. Can edit and delete records. Can view all logs.';
    rights = [
        ...new AppSecurityModule().allRights,
        ...new JobSecurityModule().allRights,
        ...new ConfigurationSecurityModule().allRights,
        ...new FinanceSecurityModule().allRights,
        ...new IndividualComplianceSecurityModule().allRights,
        ...new QuoteSecurityModule().allRights,
        ...new TimesheetSecurityModule().allRights,
        ...new TaskSecurityModule().allRights,
        ...new CrmSecurityModule().allRights,
        ...new SchedulerSecurityModule().allRights,
        // ...new PurchaseOrderSecurityModule().allRights,
        ...new WorkComplianceSecurityModule().allRights,
        ...new KnowledgeBaseSecurityModule().allRights,
        ...new ClaimSecurityModule().allRights,
        ...new ReportSecurityModule().allRights,
        ...new VariationSecurityModule().allRights,
        ...new DefectSecurityModule().allRights,
        ...new AssetSecurityModule().allRights,
        ...new EquipmentSecurityModule().allRights,
        ...new RecurringJobSecurityModule().allRights,
        ...new JobTemplatesSecurityModule().allRights,
        ...new QuoteTemplatesSecurityModule().allRights,
        ...new SalesSecurityModule().allRights,
        ...new DashboardSecurityModule().allRights,
        //  ...new ProjectsSecurityModule().allRights,

        // Not sure if they should access this
        ...new MobileTechniciansSecurityModule().allRights,

        ...new FormSecurityModule().allRights,
    ];

}

